import { useTypedParams } from '@sorare/routing';

import { Confirm as ConfirmLineupForm } from '#src/components/noCardRoute/ConfirmLineupForm/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const Confirm = () => {
  const { so5LineupId } = useTypedParams<PageParams>();

  return <ConfirmLineupForm so5LineupId={so5LineupId} />;
};

export default Confirm;
